export default __webpack_public_path__ + "2ab2d3ff6ce93e80e25d3b2683393901.png";